(() => {
  const mobile = () => window.matchMedia?.('(max-width:760px)')?.matches;

  // V196: Shopify owns the account sheet markup, but when its shadow DOM is
  // exposed we relabel the marketing opt-in to match Luck Jar's design-alert promise.
  const PROFILE_MARKETING_LABEL = 'Tell me when 4+ new designs are added to the site.';
  const PROFILE_MARKETING_OLD_LABEL = 'Email me with news and offers';
  const relabelProfileMarketingOptIn = account => {
    if (!account || account.dataset.jolMarketingRelabelBound === 'true') return;
    account.dataset.jolMarketingRelabelBound = 'true';

    const patchRoot = root => {
      if (!root) return false;
      let changed = false;
      root.querySelectorAll?.('[label],[aria-label]').forEach(el => {
        for (const attr of ['label','aria-label']) {
          if ((el.getAttribute(attr) || '').trim() === PROFILE_MARKETING_OLD_LABEL) {
            el.setAttribute(attr, PROFILE_MARKETING_LABEL);
            changed = true;
          }
        }
      });
      try {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if ((node.nodeValue || '').trim() === PROFILE_MARKETING_OLD_LABEL) {
            node.nodeValue = node.nodeValue.replace(PROFILE_MARKETING_OLD_LABEL, PROFILE_MARKETING_LABEL);
            changed = true;
          }
        }
      } catch (_) {}
      root.querySelectorAll?.('*').forEach(el => {
        if (el.shadowRoot) changed = patchRoot(el.shadowRoot) || changed;
      });
      return changed;
    };

    const run = () => {
      patchRoot(account);
      patchRoot(account.shadowRoot);
    };
    const retry = () => [0, 40, 120, 280, 650, 1200].forEach(ms => window.setTimeout(run, ms));
    account.addEventListener('open', retry);
    retry();

    if (account.shadowRoot) {
      try { new MutationObserver(run).observe(account.shadowRoot, {subtree:true, childList:true, characterData:true, attributes:true}); } catch (_) {}
    }
  };
  const bindProfileMarketingRelabel = () => document.querySelectorAll('shopify-account.jol-profile-account__component').forEach(relabelProfileMarketingOptIn);
  bindProfileMarketingRelabel();
  customElements?.whenDefined?.('shopify-account')?.then(bindProfileMarketingRelabel).catch?.(() => {});
  const pressSelector = [
    '.jol-header__action--cart',
    '.jol-hero__cta',
    '.jol-merch__button',
    '.jol-collection__view-all-button',
    '.jol-shuffle',
    '.jol-card__quick-action',
    '.jol-quickview__add',
    '.jol-fit-guide__trigger',
    '.jol-quickview__details',
    '.template-product .add-to-cart-button',
    '.template-product .jol-product-cart-link',
    '.jol-bulk-builder__add',
    '.jol-cart-preview__checkout',
    'body.template-cart .cart__checkout-button',
    "body.template-cart [data-testid='product-list'] .button-unstyled",
    '.jol-checkout-reminders__action',
    '.jol-form__submit',
    '.jol-design-alert__submit',
    '.jol-design-alert-inline__button',
    '.lj-start',
    '.lj-checkout-reward',
    '.jol-contact-footer__link',
    '.jol-mobile-nav__panel > a',
    '.jol-profile-account',
    '.jol-pathway-card'
  ].join(',');

  let held = null;
  const hold = target => {
    if (!mobile() || !target) return;
    held?.classList.remove('jol-v188-press-hold');
    held = target;
    target.classList.add('jol-v188-press-hold');
  };
  const release = () => {
    const target = held;
    if (!target) return;
    const releaseDelay = target.matches?.('.jol-shuffle') ? 180 : 40;
    window.setTimeout(() => {
      target.classList.remove('jol-v188-press-hold');
      if (held === target) held = null;
    }, releaseDelay);
  };

  document.addEventListener('pointerdown', event => {
    if (!mobile() || event.pointerType === 'mouse') return;
    hold(event.target.closest?.(pressSelector));
  }, {passive:true});
  document.addEventListener('pointerup', release, {passive:true});
  document.addEventListener('pointercancel', release, {passive:true});

  // Keep same-window mobile link navigation around long enough for the 40ms depression to read.
  document.addEventListener('click', event => {
    if (!mobile() || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
    const link = event.target.closest?.('a');
    if (!link || !link.matches(pressSelector) || !link.href || link.target === '_blank') return;
    if (link.matches('[data-jol-cart-trigger],[data-jol-product-open],[data-jol-scroll],.jol-quickview__details')) return;
    const href = link.getAttribute('href') || '';
    if (!href || href === '#' || href.startsWith('javascript:')) return;
    event.preventDefault();
    window.setTimeout(() => { window.location.href = link.href; }, 40);
  }, true);

  const closeMenus = except => {
    document.querySelectorAll('.jol-mobile-nav[open]').forEach(details => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  // Close the mobile menu when tapping outside it.
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('.jol-mobile-nav[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  }, true);

  // Any scroll closes the mobile menu, including a page-wrapper scroll in Horizon.
  document.addEventListener('scroll', () => closeMenus(), {passive:true, capture:true});

  // Make the full LJ Profile pill clickable, not only Shopify's avatar trigger.
  document.addEventListener('click', event => {
    const profile = event.target.closest?.('[data-jol-profile-account]');
    if (!profile) return;
    const mobileMenu = profile.closest('.jol-mobile-nav');
    if (mobileMenu) window.setTimeout(() => mobileMenu.removeAttribute('open'), mobile() ? 40 : 0);
    if (event.target.closest?.('shopify-account')) return;
    const account = profile.querySelector('shopify-account');
    if (!account) return;
    event.preventDefault();
    const shadowTrigger = account.shadowRoot?.querySelector('button,[role="button"],a');
    (shadowTrigger || account).click?.();
  });
})();
